export function Section({ title, children, className = '' }) {
  return (
    <section className={`bg-white rounded-lg border shadow-sm p-4 lg:p-6 ${className}`}>
      {title && <h3 className="text-lg font-semibold mb-3">{title}</h3>}
      {children}
    </section>
  )
}
